import { CanDeactivateFn } from '@angular/router';

export const saveOnExitGuard: CanDeactivateFn<unknown> = (component: any) => {
  const checkFormDirty = component.checkIfFormIsDirty();

  if (checkFormDirty) {
    return component.canDeactivateComponent();
  }
  return true;
};
